import * as React from 'react';
import { withTheme } from 'emotion-theming';
import { FormContext } from './Form';
import FormFieldContext, { ContentProps } from './FormFieldContext';

interface FormFieldProps extends ContentProps {}

const FormField: React.FC<FormFieldProps> = (props: FormFieldProps): React.ReactElement => (
    <FormContext.Consumer>
        {(context) => <FormFieldContext context={context} {...props} />}
    </FormContext.Consumer>
);

const FormFieldWrapper = withTheme(FormField);

export default FormFieldWrapper;
